import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Usuario } from '../usuario.model';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { UsuarioService } from '../usuario.service';

@Component({
  selector: 'app-usuario-visualizacao',
  templateUrl: './usuario-visualizacao.component.html',
  styleUrls: ['./usuario-visualizacao.component.css']
})

export class UsuarioVisualizacaoComponent implements OnInit {
  public usuario: Usuario;
  public mostrarModalAlteracaoSenha: boolean;
  public carregando: boolean;
  public novaSenha: string;

  constructor(
    private route: ActivatedRoute,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private usuarioService: UsuarioService
  ) { }

  ngOnInit(): void {
    this.usuario = {} as Usuario;
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.progressoService.modal();
        this.usuarioService.recuperarPorId(+params['id'])
          .then((usuario) => {
            this.progressoService.fechar();
            this.usuario = usuario;
          })
          .catch(response => {
            this.progressoService.fechar();
            this.mensagemService.addErro('Erro ao carregar o usuário', response.error);
          });
      }
    });
  }

  alterarSenhaUsuarioSistema () {
    this.carregando = true;
    this.usuario['senha'] = this.novaSenha;
    this.usuarioService.alterarSenhaUsuarioSistema(this.usuario).then(() => {
      this.carregando = false;
      this.fecharModalAlteracaoSenha();
      this.mensagemService.addSucesso('Sucesso', 'Senha alterado com sucesso!');
    }).catch(response => {
      this.carregando = false;
      this.fecharModalAlteracaoSenha();
      this.mensagemService.addErro('Erro ao carregar o usuário', response.error);
    });
  }

  abrirModalAlteracaoSenha () {
    this.mostrarModalAlteracaoSenha = true;
  }

  fecharModalAlteracaoSenha () {
    this.mostrarModalAlteracaoSenha = false;
    this.novaSenha = '';
  }


}
